import { createReducer } from '@reduxjs/toolkit';
import {
  setAuthSpinner,
  setContentSpinner,
  setFileSpinner,
  setJobsSpinner,
  setProjectsSpinner,
  setTranslateSpinner,
  setXtmActiveProjectsSpinner,
  setXtmCustomerSpinner,
  setXtmLanguagesSpinner,
  setXtmTemplateSpinner,
  toggleJobActionSpinner,
  toggleSecondJobActionSpinner,
  toggleThirdJobActionSpinner,
} from './spinner.actions';
import { ISpinnerState } from './spinner.interface';

const initState: ISpinnerState = {
  authSpinner: false,
  xtmCustomerSpinner: false,
  xtmTemplateSpinner: false,
  xtmActiveProjectsSpinner: false,
  xtmLanguagesSpinner: false,
  jobsSpinner: false,
  jobActionSpinner: false,
  thirdJobActionSpinner: false,
  secondJobActionSpinner: false,
  contentSpinner: false,
  translateSpinner: false,
  projectsSpinner: false,
  fileSpinner: false,
};

export const spinnerReducer = createReducer(initState, (builder) =>
  builder
    .addCase(setAuthSpinner, (state, { payload }) => {
      state.authSpinner = payload;
    })
    .addCase(setXtmCustomerSpinner, (state, { payload }) => {
      state.xtmCustomerSpinner = payload;
    })
    .addCase(setXtmTemplateSpinner, (state, { payload }) => {
      state.xtmTemplateSpinner = payload;
    })
    .addCase(setXtmLanguagesSpinner, (state, { payload }) => {
      state.xtmLanguagesSpinner = payload;
    })
    .addCase(setXtmActiveProjectsSpinner, (state, { payload }) => {
      state.xtmActiveProjectsSpinner = payload;
    })
    .addCase(setJobsSpinner, (state, { payload }) => {
      state.jobsSpinner = payload;
    })
    .addCase(toggleJobActionSpinner, (state, { payload }) => {
      state.jobActionSpinner = payload;
    })
    .addCase(toggleSecondJobActionSpinner, (state, { payload }) => {
      state.secondJobActionSpinner = payload;
    })
    .addCase(toggleThirdJobActionSpinner, (state, { payload }) => {
      state.thirdJobActionSpinner = payload;
    })
    .addCase(setTranslateSpinner, (state, { payload }) => {
      state.translateSpinner = payload;
    })
    .addCase(setContentSpinner, (state, { payload }) => {
      state.contentSpinner = payload;
    })
    .addCase(setProjectsSpinner, (state, { payload }) => {
      state.projectsSpinner = payload;
    })
    .addCase(setFileSpinner, (state, { payload }) => {
      state.fileSpinner = payload;
    }),
);
